import {ValidationErrorMessage} from "~/enums/validationErrorMessage";
import {ErrorType} from "~/enums/ErrorType";
import PresenceValidator from "~/models/validators/presenceValidator";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";

export default class FieldPresenceValidator<T> extends NavigableValidator<any> {
  defaultMessage = ValidationErrorMessage.MustBePresent;
  defaultType =  ErrorType.mustBePresent;
  validator = PresenceValidator.isValid;
}